// extracted by css-extract-rspack-plugin
export default {"nominationRow":"NominationsDetails_nominationRow__KYE6N"};